import { storageHandler } from './storage_handler';

function handleUnauthorized(response) {
  if (response.status === 401) {
    storageHandler.localStorageDelete('token');

    window.location.href = '/login';

    throw new Error('Unauthorized');
  }
}

const api_fetch = {
  get: async function (url, headers_json, query_json, params) {
    const query =
      Object.keys(query_json).length > 0
        ? '?' + new URLSearchParams(query_json).toString()
        : '';
    const headers = {
      ...{
        'Content-Type': 'application/json'
      },
      ...headers_json
    };
    const apiUrl = url + (params ? params : '') + query;
    const res = await fetch(apiUrl, {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    });

    handleUnauthorized(res);

    return res;
  },
  post: async function (url, headers_json, query_json, params, body) {
    const query =
      Object.keys(query_json).length > 0
        ? '?' + new URLSearchParams(query_json).toString()
        : '';
    const headers = {
      ...{
        'Content-Type': 'application/json'
      },
      ...headers_json
    };
    const res = await fetch(url + params + query, {
      method: 'POST',
      headers: headers,
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(body)
    });

    handleUnauthorized(res);

    return res;
  },
  postForm: async function (url, headers_json, query_json, params, formData) {
    const query =
      Object.keys(query_json).length > 0
        ? '?' + new URLSearchParams(query_json).toString()
        : '';

    // No need to set 'Content-Type' for multipart/form-data as it's handled by the browser
    const headers = {
      ...headers_json
    };

    return await fetch(url + params + query, {
      method: 'POST',
      headers: headers,
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: formData // FormData for file uploads
    });
  },
  patch: async function (url, headers_json, query_json, params, body) {
    const query =
      Object.keys(query_json).length > 0
        ? '?' + new URLSearchParams(query_json).toString()
        : '';
    const headers = {
      ...{
        'Content-Type': 'application/json'
      },
      ...headers_json
    };
    return await fetch(url + params + query, {
      method: 'PATCH',
      headers: headers,
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(body)
    });
  },
  put: async function (url, headers_json, query_json, params, body) {
    const query =
      Object.keys(query_json).length > 0
        ? '?' + new URLSearchParams(query_json).toString()
        : '';
    const headers = {
      ...{
        'Content-Type': 'application/json'
      },
      ...headers_json
    };

    return await fetch(url + params + query, {
      method: 'PUT',
      headers: headers,
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(body)
    });
  },
  delete: async function (url, headers_json, query_json, params, body) {
    const query =
      Object.keys(query_json).length > 0
        ? '?' + new URLSearchParams(query_json).toString()
        : '';
    const headers = {
      ...{
        'Content-Type': 'application/json'
      },
      ...headers_json
    };

    return await fetch(url + params + query, {
      method: 'DELETE',
      headers: headers,
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(body)
    });
  }
};

export default api_fetch;
